// src/reducers/mediaReducer.js

import {
  GET_PRESIGNED_URLS_SUCCESS,
  GET_IMAGES_REQUEST,
  GET_IMAGES_SUCCESS,
  GET_IMAGES_FAILURE,
  GET_PEXELS_IMAGES_REQUEST,
  GET_PEXELS_IMAGES_SUCCESS,
  GET_PEXELS_IMAGES_FAILURE,
  GET_TAGS_REQUEST,
  GET_TAGS_SUCCESS,
  GET_TAGS_FAILURE,
} from "../actions/mediaActions";

const initialState = {
  images: [],
  tags: [],
  presignedUrls: [], // Initialize the presigned URLs array
  error: null,
  loading: false,
};

const mediaReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_IMAGES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_PEXELS_IMAGES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_IMAGES_SUCCESS:
      // console.log(`PMM - SF - reducer - success action received for images`);
      // console.log(
      //   `PMM - SF - reducer - action?.payload?.images is: ${JSON.stringify(
      //     action?.payload?.images
      //   )}`
      // );
      return {
        ...state,
        images: action.payload.images, // Store fetched images in the state
        loading: false,
        error: null,
      };

    case GET_PEXELS_IMAGES_SUCCESS:
      // console.log(`PMM - SF - reducer - success action received for pexelsImages`);
      // console.log(`PMM - SF - reducer - action is: ${JSON.stringify(action)}`);
      return {
        ...state,
        pexelsImages: action.payload.photos, // Store fetched pexelsImages in the state
        loading: false,
        error: null,
      };

    case GET_IMAGES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error, // Store error message in the state
      };

    case GET_PEXELS_IMAGES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error, // Store error message in the state
      };

    case GET_PRESIGNED_URLS_SUCCESS:
      // console.log(
      //   `PMM - SF - reducer - GET_PRESIGNED_URLS_SUCCESS - action.payload:`,
      //   action.payload
      // );
      return {
        ...state,
        presignedUrls: action.payload,
        loading: false,
        error: null,
      };
    // return {
    //   ...state,
    //   presignedUrls: action.payload, // Store the presigned URLs in the state
    //   loading: false, // Stop the loading state when presigned URLs are retrieved
    //   error: null,
    // };

    case GET_TAGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_TAGS_SUCCESS:
      // console.log(`PMM - SF - reducer - success action received for tags`);
      return {
        ...state,
        tags: action.payload.tags, // Store fetched tags in the state
        loading: false,
        error: null,
      };

    case GET_TAGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error, // Store error message for tags in the state
      };

    default:
      return state;
  }
};

export default mediaReducer;
